// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelView-Container_cls1__Egbqv","cls2":"PaymentChannelView-Container_cls2__DdUWV PaymentChannelView-Container_cls1__Egbqv"};